import { render, staticRenderFns } from "./LegalSection.vue?vue&type=template&id=58e4ea74"
import script from "./LegalSection.vue?vue&type=script&lang=js"
export * from "./LegalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports